import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { ChevronRight } from 'lucide-react';
import { useBirthProfiles } from '../../hooks/useBirthProfiles';
import { useLanguage } from '../../context/LanguageContext';
import { api } from '../../lib/api';
import { ZODIACS } from '../astrology/zodiac';
import { ProfileSelect } from '../astrology/ProfileSelect';
import ShubhHeader from './ShubhHeader';
import ShubhBottomNav from './ShubhBottomNav';

export default function ShubhRashifalPage() {
  const { language } = useLanguage();
  const profiles = useBirthProfiles({ allowGeneral: true });
  const [period, setPeriod] = useState('today');
  const [moonSign, setMoonSign] = useState(null);
  useEffect(() => {
    setMoonSign(null);
    if (!profiles.profileId) return;
    const controller = new AbortController();
    api(`/kundli/profiles/${profiles.profileId}/chart`, { signal: controller.signal }).then(data => setMoonSign(data.chart.moon_sign.toLowerCase())).catch(() => {});
    return () => controller.abort();
  }, [profiles.profileId]);
  return <div className="shubh-page"><ShubhHeader title="Rashifal · राशिफल" />
    <main className="shubh-page-content pt-6"><ProfileSelect {...profiles} onChange={profiles.selectProfile} allowGeneral />
      {profiles.error && <p role="alert" data-testid="rashifal-profiles-error" className="text-red-700 mb-3">{profiles.error}</p>}
      <div className="shubh-segmented mb-6">{['today', 'week', 'month'].map((tab, i) => <button key={tab} data-testid={`rashifal-tab-${tab}`} onClick={() => setPeriod(tab)} className={`shubh-segment flex-1 ${period === tab ? 'active' : ''}`}>{language === 'hi' ? ['आज', 'सप्ताह', 'महीना'][i] : ['Today', 'Week', 'Month'][i]}</button>)}</div>
      <div className="space-y-3">{ZODIACS.map(z => <Link data-testid={`rashifal-${z.id}`} key={z.id} to={`/rashifal/${z.id}?period=${period}`} className="shubh-card shubh-card-interactive flex items-center gap-4 p-4">
        <span className="text-3xl text-[#C84B32] w-12 shrink-0" aria-hidden="true">{z.symbol}</span><div className="flex-1 min-w-0"><h2 className="text-base font-semibold">{z.name} <span className="text-sm font-normal text-[#6B6560]">{z.hindi}</span></h2><p className="text-xs text-[#6B6560] mt-1">{z.element} · {z.ruler}</p>
          {moonSign === z.id && <p data-testid="your-rashi-badge" className="text-xs text-[#287A60] mt-1">Your calculated Moon sign</p>}</div><ChevronRight className="w-4 h-4 shrink-0" /></Link>)}</div>
    </main><ShubhBottomNav /></div>;
}